// Wrap protected pages with <ProtectedRoute>. While the initial /me probe is
// in flight we render a thin loading state; once resolved we either render
// the children (authenticated) or redirect to /login preserving the intended
// destination so the post-login redirect can land back there in a follow-up.

import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "./AuthContext";
import type { ReactNode } from "react";

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation("common");

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20 text-sm text-slate-500">
        {t("loading")}
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
